import { FormattedMessage } from 'react-intl';

import type { FiltersGroup } from '@sorare/core/src/lib/filters';
import { filters } from '@sorare/core/src/lib/glossary';

import {
  BackendRefineFloorPrices,
  RefineFloorPrices,
} from '#src/searchCommonPlayer/RangeSlider/index.tsx';

export const FloorPricesGroup: FiltersGroup = {
  slug: 'floor_price',
  title: <FormattedMessage {...filters.floorPrices} />,
  filters: RefineFloorPrices(true),
};

export const BackendFloorPricesGroup: FiltersGroup = {
  slug: 'floor_price',
  title: <FormattedMessage {...filters.floorPrices} />,
  filters: BackendRefineFloorPrices(true),
};
